import React from "react";
import { motion } from "framer-motion";
import { Icon } from "@/lib/icons";

export default function Process({ data }) {
  const steps = (data?.steps || []).filter((s) => s.enabled !== false);

  return (
    <section id="process" data-testid="process-section" className="relative py-24 sm:py-32 px-6 bg-[#FBF8F1] overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          {data?.eyebrow && (
            <p className="text-[11px] uppercase tracking-[0.32em] text-[#B8941F] font-semibold mb-4">{data.eyebrow}</p>
          )}
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A0A0A]">{data?.title}</h2>
        </motion.div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <svg
            className="hidden md:block absolute top-12 left-[16%] right-[16%] h-2 z-0 pointer-events-none"
            viewBox="0 0 800 4"
            preserveAspectRatio="none"
          >
            <motion.line
              x1="0" y1="2" x2="800" y2="2"
              stroke="#D4AF37" strokeWidth="1.5" strokeDasharray="6 6"
              initial={{ pathLength: 0, opacity: 0 }}
              whileInView={{ pathLength: 1, opacity: 0.7 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: "easeInOut" }}
            />
          </svg>

          {steps.map((s, i) => (
            <motion.div
              key={s.id || s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.18 }}
              className="relative z-10 bg-white border border-[#EFEAD8] rounded-3xl p-8 sm:p-10 text-center hover:border-[#D4AF37]/50 hover:shadow-[0_22px_40px_-22px_rgba(212,175,55,0.35)] transition-all"
              data-testid={`process-step-${i}`}
            >
              <div className="mx-auto w-24 h-24 rounded-full flex items-center justify-center bg-gradient-to-br from-[#FBF8F1] to-[#FFF3C4] border border-[#D4AF37]/35 shadow-[0_0_30px_rgba(212,175,55,0.12)] mb-6">
                <Icon name={s.icon} className="w-9 h-9 text-[#B8941F]" />
              </div>
              <div className="font-display text-sm tracking-[0.4em] text-[#B8941F]/90 mb-2">STEP {s.n}</div>
              <h3 className="font-display text-2xl font-bold text-[#0A0A0A] mb-3">{s.title}</h3>
              <p className="text-gray-600 text-[15px] leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
